import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { AddProgramLevelLessonComponent } from '../add-program-level-lesson/add-program-level-lesson.component';

@Component({
  selector: 'app-program-level-lesson',
  templateUrl: './program-level-lesson.component.html',
  styleUrls: ['./program-level-lesson.component.scss']
})
export class ProgramLevelLessonComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.PROGRAM_LESSON;
  LEVEL_KEY: any;
  PROGRAM_KEY: any;
  ITEM: any;

  LOADING: boolean = true;
  constructor(
    private route: ActivatedRoute,
    public store: CurriculumStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(async (param) => {
      const { id, programKey } = param;
      this.LEVEL_KEY = id;
      this.PROGRAM_KEY = programKey;
      this.tabs = TABS.PROGRAM_LESSON.map(m => ({ path: `/programs/${programKey}/${this.LEVEL_KEY}/${m.route}`, label: m.label }))
      await this.store.fetchProgram(this.PROGRAM_KEY)
      this.ITEM = await this.store.fetchProgramLevelData(this.PROGRAM_KEY, this.LEVEL_KEY);
      this.store.fetchProgramLessons(this.PROGRAM_KEY, this.LEVEL_KEY, res => {
        this.LOADING = false;
      })
    })
  }

  ngOnDestroy(): void {
    const { fetchProgramLessonsRef } = this.store;
    fetchProgramLessonsRef && fetchProgramLessonsRef.unsubscribe();
  }

  addItem(item: any) {
    let dialogRef = this.dialog.open(AddProgramLevelLessonComponent, {
      data: {
        LESSON: item || null,
        PROGRAM_KEY: this.PROGRAM_KEY,
        LEVEL_KEY: this.LEVEL_KEY,
        LESSON_KEY: this.store.data.map(m => (m.key)),
        LEVEL: this.ITEM,
      },
      panelClass: 'item-list-panel',
      width: '45vw',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const { selectedLevel, selectedProgram } = this.store;
        const { uid } = this.auth;
        this.store.removeLesson(item, selectedLevel.key, selectedProgram.key, uid, (success) => {
          if (success) {
            this.snackBar.open("Lesson has been removed from level successful.", "Done", { duration: 2500 });
          }
        })
      }
    });
  }
}
